import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import { useCart } from "../hooks";
import HambugerIcon from "../images/HambugerIcon";
import MagnifierIcon from "../images/MagnifierIcon";
import AccountIcon from "../images/AccountIcon";
import CartIcon from "../images/CartIcon";
import MenuSection from "./modules/MenuSection";
import AnnouncementBar from "./sections/AnnouncementBar";

const LOCALE = process.env.LOCALE;

const Header = ({ siteTitle }) => {
  const data = useStaticQuery(graphql`
    {
      allDatoCmsHeader {
        edges {
          node {
            locale
            headerLogo {
              alt
              url
            }
            headerLogoAlt {
              alt
              url
            }
            sectionLinks {
              modelLink {
                ... on DatoCmsNavMenuSection {
                  id
                  sectionLabel
                  sectionLink
                  menuContent {
                    ... on DatoCmsNavSectionModelBlock {
                      id
                      modelLink {
                        ... on DatoCmsNavMenuSection {
                          id
                          sectionLabel
                          sectionLink
                          menuContent {
                            ... on DatoCmsNavSectionModelBlock {
                              id
                              modelLink {
                                ... on DatoCmsNavMenuSection {
                                  id
                                  sectionLabel
                                  sectionLink
                                }
                              }
                            }
                          }
                        }
                        ... on DatoCmsNavMenuExploreLinkColumn {
                          id
                          columnHeader
                          links {
                            linkText
                            linkUrl
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      allDatoCmsHeaderAnnouncementBar {
        edges {
          node {
            id
            locale
            announcementText
            announcementBarLink
            announcementBarTextColor {
              hex
            }
            announcementBarBackgroundColor {
              hex
            }
          }
        }
      }
      allDatoCmsNavMenuConfiguration {
        edges {
          node {
            locale
            accountButtonLink
            displayAnnouncementBar
            accountButtonLink
          }
        }
      }
    }
  `);

  const extractLocaleNode = (graphqlData) => {
    const record = graphqlData.find((record) => {
      return record.node.locale === process.env.GATSBY_LOCALE;
    });
    return record ? record.node : {};
  };

  const { headerLogo, headerLogoAlt, sectionLinks } = extractLocaleNode(
    data.allDatoCmsHeader.edges
  );
  const { accountButtonLink, displayAnnouncementBar } = extractLocaleNode(
    data.allDatoCmsNavMenuConfiguration.edges
  );
  const {
    announcementText,
    announcementBarLink,
    announcementBarTextColor,
    announcementBarBackgroundColor,
  } = extractLocaleNode(data.allDatoCmsHeaderAnnouncementBar.edges);

  const [toggleClass, setToggleClass] = useState(false);
  const [pageScrolled, setPageScrolled] = useState(false);
  const { lineItems, toggleCart } = useCart();

  const cartQty = lineItems
    .map((lineItem) => lineItem.quantity)
    .reduce((acc, curVal) => acc + curVal, 0);

  const filterLegacyItems = (navItem) => {
    return navItem.filter((item) => {
      return item;
      /*const content = item.modelLink.menuContent.filter((value) => {
        if (value.modelLink && value.modelLink.sectionLabel !== undefined) {
          return Object.keys(value).length !== 0;
        }
      });

      if (content.length) {
        item.modelLink.menuContent = content;
        return item;
      }*/
    });
  };
  const filteredLinks = filterLegacyItems(sectionLinks);

  const handleScroll = () => {
    const isPageScrolled = window.pageYOffset ? true : false;
    setPageScrolled(isPageScrolled);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className="sticky top-0 w-full z-40">
      <AnnouncementBar
        isDisplayed={displayAnnouncementBar}
        text={announcementText}
        link={announcementBarLink}
        bgColor={announcementBarBackgroundColor}
        textColor={announcementBarTextColor}
      />
      <header
        className={`hds-navbar__bg-color hds-navbar__text-color px-5 sm:px-sm shadow-lg relative header-transition ${
          pageScrolled ? "scrolled" : ""
        }`}
      >
        <div className="max-w-screen-xl mx-auto ">
          <div className="items-center py-2" >
            {headerLogo && (
                <Link to="/" className="flex justify-center items-center">
                  <img
                      src={`${pageScrolled ? headerLogo.url : headerLogoAlt.url}`}
                      alt="Thermacell Logo"
                      className={`logo z-20`}
                  />
                </Link>
            )}
          </div>
          <div className="flex justify-between items-center py-2">
            <button
              id="open-menu"
              className="py-sm mr-xs phone:hidden"
              aria-label="Open Navigation"
              onClick={() => {
                setToggleClass(true);
              }}
            >
              <HambugerIcon />
            </button>
            {headerLogo && (
              <Link to="/" className="flex justify-center items-center">
                <img
                  src={`${pageScrolled ? headerLogo.url : headerLogoAlt.url}`}
                  alt="Thermacell Logo"
                  className={`logo z-20 hidden`}
                  style={{ visibility: "hidden"}}
                />
              </Link>
            )}
            <div
              id="mobile-menu-wrapper"
              className={`${
                !toggleClass ? "hidden" : ""
              } phone:flex fixed phone:static inset-0 phone:inset-auto flex-col phone:flex-row phone:items-center py-xs phone:p-0 z-10 hds-navbar__bg-color header-transition main_navigation_padding`}
            >
              <button
                id="close-menu"
                className={`hds-title__large phone:hidden self-start ml-sm header-transition ${
                  pageScrolled ? "text-black" : "text-white"
                }`}
                aria-label="Close Navigation"
                onClick={() => {
                  setToggleClass(false);
                }}
              >
                ×
              </button>
              {headerLogo && (
                  <Link to="/" className="flex-grow phone:flex-grow-0 px-sm phone:px-0 w-full text-xl phone:text-sm phone:pt-0 phone:order-1 md:hidden">
                    <img
                        src={`${pageScrolled ? headerLogo.url : headerLogoAlt.url}`}
                        alt="Thermacell Logo"
                        className={`logo_navigation z-20`}
                    />
                  </Link>
              )}
              <nav
                aria-label="Main Navigation"
                className="header-nav flex-grow phone:flex-grow-0 px-sm phone:px-0 w-full text-xl phone:text-sm pt-10 phone:pt-0 phone:order-1 nav-list"
              >
                <ul
                  role="list"
                  className="menu-items relative phone:static flex flex-col phone:flex-row nav-list font-body"
                >
                  {filteredLinks &&
                    filteredLinks.map((link, index) => {
                      return (
                        <MenuSection
                          link={link}
                          index={index}
                          pageScrolled={pageScrolled}
                          key={index}
                        />
                      );
                    })}
                </ul>
              </nav>
            </div>
            <div className="flex items-center z-0 md:z-20">
              <a href={accountButtonLink} className="mr-xs">
                <AccountIcon css="w-auto h-5" />
              </a>
              <Link className="block mr-xs" to="/search">
                <div className="">
                  <MagnifierIcon css="w-auto h-5" />
                </div>
              </Link>
              <a
                id="cart-trigger"
                className="relative cursor-pointer"
                onClick={() => toggleCart()}
              >
                <span
                  className={`hds-legal absolute w-6 p-1 font-bold text-center rounded-full bg-primary text-white ${
                    cartQty === 0 ? "hidden" : ""
                  }`}
                  style={{ top: "-8px", right: "-8px" }}
                >
                  {cartQty}
                </span>
                <CartIcon css="w-auto h-5" />
              </a>
            </div>
          </div>
        </div>
      </header>
      <div
        id="cart-container"
        className="hds-text-color hidden fixed z-20 inset-0 bg-black bg-opacity-0 transition duration-500 ease-in-out"
      >
        <div className="flex justify-end ">
          <div
            id="cart-wrapper"
            className="flex flex-col w-80 h-screen bg-white transition duration-500 ease-in-out transform translate-x-80"
          >
            <div className="bg-white border-b-2 text-primary flex justify-between items-center p-sm">
              <span className="hds-copy font-heading uppercase font-bold">
                Shopping Cart
              </span>
              <span className="hds-title__medium text-black">
                <a id="close-cart" href="#">
                  ×
                </a>
              </span>
            </div>
            <div className="flex-grow p-sm overflow-auto">
              <div className="flex items-center py-sm border-b-2">
                <div className="w-full">
                  <div className="flex">
                    <div className="w-24 h-24 mr-sm">
                      <div className="relative h-full bg-primary rounded-md overflow-hidden">
                        {/* <img className="top-0 w-full h-full min-h-1/2 object-cover absolute z-0" src="https://csb-72hdo-startingblock.vercel.app/images/products/product-3.png" alt=""> */}
                        img
                      </div>
                    </div>
                    <div className="flex-grow">
                      <p className="hds-copy mb-xs font-bold">
                        Scout Mosquito Repellent Camp Lantern
                      </p>
                      <div>
                        <p className="hds-legal mb-xs">Quantity: 2</p>
                        <p className="hds-legal font-bold">$25</p>
                      </div>
                    </div>
                    <button className="hds-title__small">×</button>
                  </div>
                </div>
              </div>
              <div className="flex items-center py-sm border-b-2">
                <div className="w-full">
                  <div className="flex">
                    <div className="w-24 h-24 mr-sm">
                      <div className="relative h-full bg-primary rounded-md overflow-hidden">
                        {/* <img className="top-0 w-full h-full min-h-1/2 object-cover absolute z-0" src="https://csb-72hdo-startingblock.vercel.app/images/products/product-6.png" alt=""> */}
                        img
                      </div>
                    </div>
                    <div className="flex-grow">
                      <p className="hds-copy mb-xs font-bold">
                        Repellent Camp Lantern
                      </p>
                      <div>
                        <p className="hds-legal mb-xs">Quantity: 2</p>
                        <p className="hds-legal font-bold">$25</p>
                      </div>
                    </div>
                    <button className="hds-title__small">×</button>
                  </div>
                </div>
              </div>
              <div className="flex items-center py-sm border-b-2">
                <div className="w-full">
                  <div className="flex">
                    <div className="w-24 h-24 mr-sm">
                      <div className="relative h-full bg-primary rounded-md overflow-hidden">
                        {/* <img className="top-0 w-full h-full min-h-1/2 object-cover absolute z-0" src="https://csb-72hdo-startingblock.vercel.app/images/products/product-10.png" alt=""> */}
                        img
                      </div>
                    </div>
                    <div className="flex-grow">
                      <p className="hds-copy mb-xs font-bold">
                        Patio Shield Mosquito Repellent Lantern
                      </p>
                      <div>
                        <p className="hds-legal mb-xs">Quantity: 2</p>
                        <p className="hds-legal font-bold">$25</p>
                      </div>
                    </div>
                    <button className="hds-title__small">×</button>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-sm border-t-2">
              <div className="hds-copy flex justify-between flex-wrap mb-sm">
                <span>Total price: </span>
                <span className="font-bold">$12,492</span>
              </div>
              <button
                className="hds-btn rounded-full font-heading hds-btn__secondary w-full"
                type="button"
              >
                Checkout
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

Header.propTypes = {
  siteTitle: PropTypes.string,
};

Header.defaultProps = {
  siteTitle: ``,
};

export default Header;
